import { ExploreQueryParams } from '../../../../../components/Maps/types/types';

import { CatchesIcon } from './CatchesIcon';
import { MapDrawerMenuButton } from './MapDrawerMenuButton';
import { MapLayersIcon } from './MapLayersIcon';
import { RegulationsIcon } from './RegulationsIcon';

export const MapDrawerMenu = () => (
  <>
    <MapDrawerMenuButton
      icon={<CatchesIcon />}
      isActive={(query: ExploreQueryParams) =>
        query.drawerView === 'catches' ||
        query.drawerView === 'catch' ||
        query.drawerView === 'filter-catches'
      }
      view="catches"
    >
      Catches in area
    </MapDrawerMenuButton>
    <MapDrawerMenuButton
      icon={<RegulationsIcon />}
      isActive={(query: ExploreQueryParams) =>
        query.drawerView === 'regulations' || query.drawerView === 'regulation'
      }
      view="regulations"
    >
      Regulations
    </MapDrawerMenuButton>
    <MapDrawerMenuButton
      icon={<MapLayersIcon />}
      isActive={(query: ExploreQueryParams) =>
        query.drawerView === 'map-layers' ||
        query.drawerView === 'poi-settings' ||
        query.drawerView === 'waypoints-settings' ||
        query.drawerView === 'fishing-waters-settings'
      }
      view="map-layers"
    >
      Map layers
    </MapDrawerMenuButton>
  </>
);
